var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_14149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.183594 13.8413C0.183594 13.4336 0.603777 13.1649 0.968915 13.3391L18.5836 21.7526C18.7763 21.8453 18.8992 22.0399 18.8992 22.2548V45.2586C18.8992 45.6663 18.479 45.935 18.1139 45.7608L0.49919 37.3473C0.30653 37.2546 0.183594 37.06 0.183594 36.845V13.8413Z",
    fill: "url(#paint0_linear_106_14149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6514 45.2471C21.6514 45.6585 22.0771 45.9272 22.4422 45.7474L39.5064 37.3506C39.6954 37.2579 39.8165 37.0633 39.8165 36.8502V13.8521C39.8165 13.4407 39.3908 13.172 39.0257 13.3517L21.9615 21.7485C21.7725 21.8412 21.6514 22.0358 21.6514 22.2489V45.2452V45.2471Z",
    fill: "url(#paint1_linear_106_14149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17993 10.3697C0.770753 10.1658 0.770753 9.57651 1.17993 9.37266L19.4478 0.241969C19.6019 0.164135 19.7818 0.164135 19.9359 0.241969L38.2019 9.37266C38.6093 9.57651 38.6093 10.1658 38.2019 10.3697L19.9359 19.5004C19.7818 19.5782 19.6019 19.5782 19.4478 19.5004L1.17993 10.3697Z",
    fill: "url(#paint2_linear_106_14149)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_14149",
    x1: 18.8992,
    y1: 22.7013,
    x2: 0.0400084,
    y2: 37.5296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#962121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#962121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_14149",
    x1: 21.6514,
    y1: 22.701,
    x2: 39.9534,
    y2: 36.8866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#962121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#962121",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_14149",
    x1: 19.6903,
    y1: 0.183594,
    x2: 19.6903,
    y2: 19.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#962121",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#962121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_14149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadErrorIcon);
export default __webpack_public_path__ + "static/media/fileUploadErrorIcon.5a97ecbfb22940196f1ff6d07449ae76.svg";
export { ForwardRef as ReactComponent };